import React from "react";
import { Col, Row, Divider } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { APP_ROUTES } from "../../../constants/Routes";

const DesignationHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">
            {<IntlMessages id={"Addnew.designation"} />}
          </p>
        </Col>
        <Col>
          <Link to={APP_ROUTES.ADDNEWDESIGNATION}>
            <ButtonComponent
              type="primary"
              label={<IntlMessages id={"Addnew.designation.add"} />}
              icon={<PlusCircleOutlined />}
            />
          </Link>
        </Col>
      </Row>

      <Divider />
    </div>
  );
};

export default DesignationHeader;
